/**
 * Checks if the provided value is of boolean type.
 *
 * @param value - The value to check.
 * @returns True if the value is a boolean, otherwise false.
 */
export const isBoolean = (value: unknown): value is boolean =>
  typeof value === "boolean";
